import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ColorsListDropDown from "../../../common/components/input/ColorsListDropDown";
import styled, { css } from "styled-components";
import { toJS } from "mobx";

import CriteriaPanel from "../../common/Criteria/CriteriaPanel";
import { StyledTooltip } from "../../../common/utils/StyledTooltip";
import MultiSelect from "../../../common/components/input/MultiSelect";
import ColorsSet from "../../../common/utils/ColorsSet";

function RowAndCellColoring({
  colorValues,
  coloringType,
  columnsForCriteriaPanel,
  listId,
  setColorValues,
  handleColorButtonSave,
}) {
  const handleDeleteColor = (index) => {
    let tempColorValues = colorValues.slice();
    tempColorValues.splice(index, 1);
    setColorValues(tempColorValues);
    if (tempColorValues.length == 0) {
      handleColorButtonSave(true);
    }
  };

  const handleSetColor = (col, index) => {
    let tempColorValues = colorValues.slice();
    tempColorValues[index]["bg_color"] = col;
    setColorValues(tempColorValues);
  };

  const handleSelectedColumn = (values, index) => {
    let tempColorValues = colorValues.slice();
    tempColorValues[index]["column_id"] = values;
    setColorValues(tempColorValues);
  };

  const handleCriteriaChange = React.useCallback(
    (criteria, index) => {
      if (colorValues[index]["criteria"]["query_string"] !== criteria) {
        setColorValues((colorValues) => {
          // const newColorValues = [...colorValues];
          // newColorValues[index]["criteria"]["query_string"] = criteria;
          // return newColorValues;
          try {
            colorValues[index]["criteria"]["query_string"] = criteria;
          } catch (error) {
            return colorValues;
          }
          return colorValues;
        });
      }
    },
    [setColorValues, colorValues]
  );

  return colorValues.map((colorVal, index) => (
    <StyledGrid key={colorVal.index} container>
      <StyledInnerGrid container>
        <StyledInnerGridItem item>
          <StyledTooltip title="Remove color">
            <StyledDeleteIcon
              onClick={() => {
                handleDeleteColor(index);
              }}
            />
          </StyledTooltip>
        </StyledInnerGridItem>
        <StyledInnerGridItem item>
          <ColorsListDropDown
            colors={ColorsSet}
            onChange={(col) => handleSetColor(col, index)}
            value={colorVal.bg_color}
            isShowArrowDropDownIcon={true}
          />
        </StyledInnerGridItem>
        <Grid item>Define a condition</Grid>
      </StyledInnerGrid>
      <StyledCriteriaPanelGrid container>
        {coloringType === "column" && (
          <StyledCriteriaPanelInnerGrid container>
            <StyledCriteriaPanelInnerGridItem item>
              <b>Columns to Color:</b>
            </StyledCriteriaPanelInnerGridItem>
            <Grid className="multiselect" item xs={6}>
              <MultiSelect
                id="columns"
                options={[...columnsForCriteriaPanel]}
                value={colorVal.column_id}
                placeholder="Select columns"
                valueKey={"id"}
                displayKey={"name"}
                onChange={(e, values) => {
                  handleSelectedColumn(values, index);
                }}
              />
            </Grid>
          </StyledCriteriaPanelInnerGrid>
        )}
        <CriteriaPanel
          onChange={(criteria) => {
            handleCriteriaChange(criteria, index);
          }}
          value={
            typeof colorVal.criteria === "object"
              ? toJS(colorVal.criteria)
              : colorVal.criteria
          }
          lookupColumns={columnsForCriteriaPanel}
          lookupListId={listId}
          currentSheetColumns={columnsForCriteriaPanel}
          currentListId={listId}
          hiddenMultiLevels={false}
          floatingCriteriaButton
          addButtonText={"+ Add Condition"}
          isCenterAlignedCriteriaButton={true}
          colorValIndex={colorVal?.index}
        />
      </StyledCriteriaPanelGrid>
    </StyledGrid>
  ));
}

const StyledGrid = styled(Grid)`
  padding: 10px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

const StyledInnerGrid = styled(Grid)`
  padding: 5px 5px 10px 5px;
  display: flex;
  align-items: center;
`;

const StyledInnerGridItem = styled(Grid)`
  margin-right: 6px !important;
  display: flex;
`;

const StyledCriteriaPanelGrid = styled(Grid)`
  padding-left: 18px;
`;

const StyledCriteriaPanelInnerGrid = styled(Grid)`
  padding: 8px;
  display: flex;
  align-items: center;
  align-self: center;
`;

const StyledCriteriaPanelInnerGridItem = styled(Grid)`
  height: 100%;
  padding: 6px 8px 6px 0px;
`;

const StyledDeleteIcon = styled(DeleteIcon)`
  font-size: 12px !important;
`;

export default RowAndCellColoring;
